// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__2c2s-","list__wrapper":"List_list__wrapper___3QJH","title":"List_title__3p8gB","list__item":"List_list__item__3xe7y","arrow":"List_arrow__bySk6"};